import React, { useContext, useEffect, useRef, useState } from "react";
import { Modal } from "bootstrap";
import $ from "jquery";
import { ValidationInfoMessage } from "../../../../Layout/Common/alert/validationInfoMessage";
import "select2";
import { isValidArray } from "../../../../Layout/Common/common";
import { axiosInstance } from "../../../../axios/axiosInstance";
import { useGlobalFunction } from "../../../../Context/GlobalFunctionContext";
import { SuccessMessageContainer } from "../../../../Layout/Common/alert/SuccessMessageContainer";

export const AddItemByCode = ({ show, setShow, listId, updateList }) => {
  const modalRef = useRef(null);
  const modalInstance = useRef(null);
  const selectRef = useRef(null);
  const [errorMessage, SetErrorMessage] = useState("");
  const [infoTittle, setInfoTittle] = useState("Order Code Not Found");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [activeSuggestion, setActiveSuggestion] = useState(-1);
  const suggestionListRef = useRef(null);
  const [productCode, setProductCode] = useState("");
  const [suggestion, setSuggestion] = useState(null);
  const { addToWishList } = useGlobalFunction();
  const successMessageRef = useRef(null);
  useEffect(() => {
    if (modalRef.current) {
      modalInstance.current = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: false,
      });
      if (show) handleShow();
      else handleHide();
    }
  }, [show]);

  const handleShow = () => {
    modalInstance.current?.show();
  };

  const handleHide = () => {
    setShow(false);
    modalInstance.current?.hide();
  };
  const handleOnType = (e) => {
    if (e.target.value || e.target.value == "") {
      setProductCode(String(e.target.value).trim());
      handleOnSearch(String(e.target.value).trim());
    }
    if (successMessageRef.current) {
      successMessageRef.current.hideAlert();
    }
    SetErrorMessage("");
  };
  const handleOnSearch = (txt) => {
    if (txt == "") setSuggestion([]);
    else {
      axiosInstance
        .post("GetStaticData/ProductCodeAutoComplete", {
          sku: txt,
        })
        .then((response) => {
          if (response.data) {
            setSuggestion(response.data);
          }
        })
        .catch((error) => console.log(error.message));
    }
  };
  const autosuggestionKeyPress = (e) => {
    if (e.key == "ArrowDown" && activeSuggestion < suggestion.length - 1) {
      //setactiveSuggestion(parseInt(activeSuggestion) + 1);
      setActiveSuggestion((prev) => {
        const nextIndex = prev < suggestion.length - 1 ? prev + 1 : 0;
        scrollToActiveSuggestion(nextIndex);
        return nextIndex;
      });
    } else if (e.key == "ArrowUp" && activeSuggestion > 0) {
      setActiveSuggestion((prev) => {
        const nextIndex = prev > 0 ? prev - 1 : suggestion.length - 1;
        scrollToActiveSuggestion(nextIndex);
        return nextIndex;
      });
    } else if (e.key == "Enter") {
      if (activeSuggestion >= 0 && activeSuggestion < suggestion.length) {
        setProductCode(suggestion[activeSuggestion].code);
        setShowSuggestions(false);
      }
    }
  };
  const scrollToActiveSuggestion = (index) => {
    const list = suggestionListRef.current;
    if (list) {
      const item = list.children[index + 2] || list.children[index + 1] || list.children[index];

      if (item) {
        item.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  };

  const handleAddClick = async () => {
    if (productCode && listId) {
      var response = await addToWishList({
        listId: listId,
        productId: productCode,
      });

      if (response) {
        setProductCode("");
        successMessageRef.current.showAlert("Success", "Your Item has beed added to this favourote list");
        updateList();
      } else {
        setInfoTittle("Order Code Not Found");
        SetErrorMessage("You Entered Order Code is Invalid, Please Re-enter Order Code.");
      }
    }
  };

  return (
    <>
      <div
        className="modal fade"
        id="addFavModal"
        tabIndex={-1}
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-dialog-centered modal-animate-center product-notfound-dialog">
          <div className="modal-content">
            <p className="order-status-close" data-bs-dismiss="modal" onClick={handleHide}>
              <i className="fa-regular fa-circle-xmark" />
            </p>
            <div className="modal-body p-0">
              <div className="product-found">
                <div className="product-found-title">
                  <span className="wes-order-summitted" />
                  <h4>Add Item by Order Code</h4>
                </div>
                <div className="product-found-body">
                  <div className="mb-3">
                    <label className="fs-15 mb-2">Order Code</label>
                    <input
                      type="text"
                      onChange={handleOnType}
                      value={productCode}
                      autoComplete="off"
                      data-required="true"
                      className="form-control"
                      name="textbox"
                      placeholder="Enter Order Code"
                      onFocus={() => setShowSuggestions(true)}
                      onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                      onKeyDown={autosuggestionKeyPress}
                    />
                    {showSuggestions && isValidArray(suggestion) && (
                      <div style={{ display: "block", position: "relative" }}>
                        <ul ref={suggestionListRef} className="autosuggest-suggestions">
                          {suggestion.map((item, index) => (
                            <li
                              key={index}
                              onClick={() => {
                                setProductCode(String(item.code).trim());
                              }}
                              className={index == activeSuggestion ? "active" : ""}
                            >
                              {String(item.code).trim()}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    <p className="form-info fs-14 bg-darkGrey fw-normal mx-0 py-2">Ex: BPA-38SN</p>
                  </div>
                  <div className="product-foundButton">
                    <div className="button-effect">
                      <button role="button" className="btn btn-products theme-primary" onClick={handleAddClick}>
                        <i className="fa-solid fa-check" /> Add Item
                      </button>
                    </div>
                  </div>
                  <SuccessMessageContainer ref={successMessageRef} />
                  <ValidationInfoMessage
                    title={infoTittle}
                    message={errorMessage}
                    handleHidden={() => {
                      SetErrorMessage("");
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
